module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/iPhone-back-311da2d76753430f3d76a5d28637ecff.svg";